// extracted by mini-css-extract-plugin
export default {"heading":"gw-z","corrected":"hw-z","redirectVerbiageContainer":"iw-z","redirectVerbiageText":"jw-z"};